import { useQuery } from '@apollo/client'
import { useSelector } from 'react-redux'

import { ShippingReportFeatureDocument } from '__generated__/atlas-types'

import { GlobalIdTypes, toGlobalId } from 'utils/transformations/graphql'

import { atlasClient } from 'graphql/client'
import { getAccountId } from 'store/currentUser/selectors'

export const useShippingReportFeatureQuery = (skip?: boolean) => {
  const accountId = useSelector(getAccountId)

  return useQuery(ShippingReportFeatureDocument, {
    client: atlasClient,
    variables: {
      accountId: toGlobalId(GlobalIdTypes.ACCOUNT, accountId) || '',
    },
    skip,
  })
}
